import { validateBoxInfo } from '@f/validation/datalayer';
import tagManagerService from '@f/services/TagManager';

export function DataEventBoxInfo(infoLabel: string, pageUrl?: string) {
	tagManagerService.push({
			event: 'boxInfo',
			infoLabel,
			pageUrl: pageUrl || window.location.href 
	}, validateBoxInfo)
}